import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import template from '../../helpers/template';

const DataComponentTableStyle = ({ binaryData, data, classTemplate }) => {
    const getStyle = useCallback((index) => {
        if (!classTemplate) return null;
        return `${template(classTemplate, { index: index + 1 })} {display:none;}`;
    }, [classTemplate]);

    const renderBinaryData = useCallback(() => {
        const bin = typeof binaryData === 'string' ? binaryData : '';
        if (!bin || bin.length === 0) return null;

        const count = bin.length;

        return (
            <React.Fragment>
                {Array.from({ length: count }).map((_, i) => {
                    const active = bin.charAt(i) === '1';
                    if (!active && i !== 0) {
                        return getStyle(i);
                    }
                    return null;
                })}
            </React.Fragment>
        );
    }, [binaryData, getStyle]);

    const renderData = useCallback(() => {
        const arr = Array.isArray(data) ? data : [];
        if (arr.length === 0) return null;

        return (
            <React.Fragment>
                {arr.map((item, i) => {
                    const active = item && (item.disabled ? true : !!item.visible);
                    if (!active) {
                        return getStyle(i);
                    }
                    return null;
                })}
            </React.Fragment>
        );
    }, [data, getStyle]);

    return (
        <style>
            {renderBinaryData()}
            {renderData()}
        </style>
    );
};

DataComponentTableStyle.propTypes = {
    binaryData: PropTypes.string,
    data: PropTypes.array,
    classTemplate: PropTypes.string
};

DataComponentTableStyle.defaultProps = {
    binaryData: '',
    classTemplate: '',
    data: []
};

export default DataComponentTableStyle;
